export default __webpack_public_path__ + "static/media/black_bean.25b7f4df.wav";